import { render, staticRenderFns } from "./navBar.vue?vue&type=template&id=86823f5a&scoped=true&"
import script from "./navBar.vue?vue&type=script&lang=ts&"
export * from "./navBar.vue?vue&type=script&lang=ts&"
import style0 from "./navBar.vue?vue&type=style&index=0&id=86823f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86823f5a",
  null
  
)

export default component.exports